import React from "react";
import { ReactComponent as Logo } from '../assets/footerlogo.svg';
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Footer = () => {
	const redes = [
		{ icon: FaWhatsapp, url: "https://api.whatsapp.com/send/?phone=522224292114&text&type=phone_number&app_absent=0" },
		{ icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=100069422446802#" },
		{ icon: FaInstagram, url: "https://www.instagram.com/nemesissc7/" },
		{ icon: FaLinkedin, url: "https://www.linkedin.com/in/dist-empresarial-nemesis-262196214/" },
	];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-[#00245D] shadow text-white">
			<div className="grid grid-cols-2 md:grid-cols-4">
				<div className="w-full flex justify-center items-center">
					<Logo className="w-44"/>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> Contáctenos </h2>
					<p> (52) 2224292114 </p>
					<p> dis.nemesis0806@outlook.com </p>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> Dirección </h2>
					<p>
						{" "}
						CPrivada 3 B Sur, Número EXT. 3705
						Col. Gabriel Pastor, Heroica Puebla de Zaragoza. C.P. 72420
						{" "}
					</p>
				</div>
				<div className="flex flex-row justify-center gap-8 py-8">
					{redes.map((red, index) => {
						const Icon = red.icon;
						return (
							<a
								key={index}
								href={red.url}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={red.name}
								className="text-white text-2xl hover:text-yellow-300 transition-colors"
							>
								<Icon />
							</a>
						);
					})}
				</div>
			</div>
		</footer>
	);
};

export default Footer;
